import api from "@api";

import {log} from "@helpers";

const updatePlano = async (planoId, setCurrentProgress) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser"));
  if (!currentUser) return;
  const payload = {
    pathWithDomain: `${process.env.REACT_APP_API_V2}/api/v1/forma_pagamento/change_subscription/plans/${planoId}`,
    method: "PUT",
  };
  log("PUT updatePlano:", payload);

  return api(payload, setCurrentProgress);
};

export default updatePlano;
